import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=19dc3f5c"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports